// extracted by mini-css-extract-plugin
export default {"sentiment_world_chart":"styles-module__sentiment_world_chart___txFow","big_screen":"styles-module__big_screen___IJXDG"};